import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Transporter } from 'src/app/core/models/transporter';
import { TransporterService } from 'src/app/core/services/general/transporter.service';
import { CreateTransporterModalComponent } from '../create-transporter-modal/create-transporter-modal.component';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-transporter-input',
  templateUrl: './transporter-input.component.html',
  styleUrls: ['./transporter-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: TransporterInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: TransporterInputComponent,
    },
  ],
})
export class TransporterInputComponent {
  @Input()
  title = "Select Transporter...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public transportersList: Array<CustomSelectOption> = [];

  constructor(
    private transporterService: TransporterService,
    private modalService: NgbOffcanvas,
  ) {
    this.transporterService
      .all()
      .subscribe((res: Array<Transporter>) => {
        this.transportersList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.transportersList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }


  createNewTransporter() {
    const modalRef = this.modalService.open(CreateTransporterModalComponent, {
      position: 'end',
      panelClass: "w-75"
    });
    modalRef.result.then(() => {
      let createdTransporterString = localStorage.getItem('created-transporter');
      if (createdTransporterString) {
        localStorage.removeItem('created-transporter');
        let createdTransporter = new Transporter(JSON.parse(createdTransporterString)!);
        this.transportersList.push({
          name: `${createdTransporter.name}`,
          value: createdTransporter.uuid,
        });
        this.onValueChange(this.transportersList.filter((el) => el.value == createdTransporter.uuid)[0])
      }
    });
  }
}
